export type MailRouteApplicationState = 'idle' | 'queued' | 'applying' | 'active' | 'failed';

export type MailRouteApplicationResponse = {
  available: boolean;
  state: MailRouteApplicationState;
  requested_revision: number | null;
  active_revision: number | null;
  error: string | null;
};

export type MailRouteApplication = {
  available: boolean;
  state: MailRouteApplicationState;
  requestedRevision: number | null;
  activeRevision: number | null;
  error: string | null;
};

export function mapMailRouteApplication(response: MailRouteApplicationResponse): MailRouteApplication {
  return {
    available: response.available,
    state: response.state,
    requestedRevision: response.requested_revision,
    activeRevision: response.active_revision,
    error: response.error ?? null
  };
}

export function canApplyMailRouteApplication(draftRevision: number, application: MailRouteApplication | null): boolean {
  return Boolean(
    application?.available
      && application.state !== 'queued'
      && application.state !== 'applying'
      && application.activeRevision !== draftRevision
  );
}

export function isMatchingActiveMailRouteApplication(draftRevision: number, application: MailRouteApplication | null): boolean {
  return Boolean(
    application?.available
      && application.state === 'active'
      && application.requestedRevision === draftRevision
      && application.activeRevision === draftRevision
  );
}
